module.exports = __webpack_public_path__ + "src/img/zalando/img-returns.91bb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-returns.jpg
// module id = 265
// module chunks = 0